import { Images } from '@/assets/images';
import {
	AgriFranchiseEnum,
	BusinessType,
	FisheryFranchiseEnum,
	REGEX,
} from '@/constant';
import { cn, dayjs, formatDate, insertObjectIf } from '@/utils';

import { includes } from 'ramda';
import { isNotNilOrEmpty } from 'ramda-adjunct';

import { FormConfig } from '../define-document-write.type';

const BASIC_CONFIRM = ['1', '2'];

const initializeValue = {
	employeeCfmRecruiterName: '',
	recruiterBirth: '',
	employeeCfmAgriFisheryRegisNo: '',
	employeeCfmRecruiterPhone: '',
	employeeCfmFranchiseName: '',
	employeeCfmFranchiseAddr: '',
	employeeCfmBusinessRegisNo: '',
	employeeCfmFranchisePhone: '',

	basicPlanConfirm: '1',
	recruitType: '',
	franchiseWorkplace: '',
	totalNumReq: '',
	totalNumDispatchWorker: '',
	employeeCfmRegistDate: '',
	employeeCfmDistrict: '',
	employeeCfmCity: '',
	employeeCfmRegistName: '',
	employeeCfmSignature: '',
	position: '', // '시‧군',

	// 7: Payment
	wage: '',
	wageEn: '',
	timePerWage: '',
	timePerWageEn: '',
	bonusOrExtraPay: '2', // uncheck
	bonusOrExtraPayEn: '2', // uncheck
	bonusPay: '',
	bonusPayEn: '',
	extraPay: '',
	extraPayEn: '',
	wageProbationPeriod: '',
	wageProbationPeriodEn: '',
	threeMonthsProbationPeriod: '',
	threeMonthsProbationPeriodEn: '',
	overTimeRate: '',
	overTimeRateEn: '',

	// 8: Payment date
	paymentDatePerMonth: '',
	paymentDatePerMonthEn: '',
	paymentDatePerWeek: '',
	paymentDatePerWeekEn: '',

	// 9: Payment methods
	paymentMethod: '2', // uncheck
	paymentMethodEn: '2', // uncheck

	// 1s: Accommodations and Meals
	provideAccommondationStatus: '2', // uncheck
	provideAccommondationStatusEn: '2', // uncheck

	provideAccommondationType: [] as string[],
	provideAccommondationTypeEn: [] as string[],

	specifyBoarding: '',
	specifyBoardingEn: '',
	// specifyBoardingInput: '',
	// specifyBoardingInputEn: '',
	accommodationCost: '',

	provideMeals: '2', // uncheck
	provideMealsEn: '2', // uncheck
	mealsType: [] as string[],
	mealsTypeEn: [] as string[],
	mealsCost: '',
	mealsCostEn: '',

	// 11: date-name-signature
	standardEmplCtrRegistDate: '',
	standardEmployer: '',
	standardEmployerEn: '',
	standardEmployerSignature: '',
	standardEmplCtrEmployee: '',
	standardEmplCtrEmployeeEn: '',
	standardEmplCtrSignature: '',
};

type IValues = typeof initializeValue;

export const CONFIRM_EMPLOYER_PLACE_WORKER_CONFIG: FormConfig<IValues> = {
	initializeValue,
	title: '계절근로자 배치 대상 고용주 확인서',
	mapPropToValues({ franchiseData, detailData, latestAssignmentData }) {
		const unitInfo = detailData?.unitInfo;
		const adminInfo = detailData?.adminInfo;

		return {
			...insertObjectIf(
				isNotNilOrEmpty(franchiseData) &&
					includes(franchiseData?.typeDetail, [
						AgriFranchiseEnum.AGRICULTURAL_BUSINESS_HOUSEHOLD,
						AgriFranchiseEnum.AGRICULTURAL_PRODUCT_PROCESSING_COMPANY,
						FisheryFranchiseEnum.FISHING_OPERATION_HOUSEHOLD,
						FisheryFranchiseEnum.FISHING_PRODUCT_PROCESSING_COMPANY,
					]),
				{
					employeeCfmRecruiterName: franchiseData?.employerName,
					recruiterBirth: franchiseData?.employerBirthDate,
					employeeCfmAgriFisheryRegisNo: franchiseData?.businessRegistNo,
					employeeCfmRecruiterPhone: franchiseData?.employerPhone,
				}
			),
			...insertObjectIf(
				isNotNilOrEmpty(franchiseData) &&
					includes(franchiseData?.typeDetail, [
						AgriFranchiseEnum.AGRICULTURAL_CORPORATION_ASSOCIATION,
						AgriFranchiseEnum.PUBLIC_FRANCHISE,
						FisheryFranchiseEnum.FISHING_CORPORATION_ASSOCIATION,
					]),
				{
					employeeCfmFranchiseName: franchiseData?.name,
					employeeCfmFranchiseAddr: franchiseData?.employerName,
					employeeCfmBusinessRegisNo: franchiseData?.corporateRegistNo,
					employeeCfmFranchisePhone: franchiseData?.phone,
				}
			),
			recruitType:
				franchiseData?.type === BusinessType.AGRICULTURAL ? '1' : '2',
			franchiseWorkplace: franchiseData?.name,
			totalNumReq: latestAssignmentData?.requestApplicant
				? String(latestAssignmentData?.requestApplicant)
				: '',
			totalNumDispatchWorker: latestAssignmentData?.assignmentApplicant
				? String(latestAssignmentData?.assignmentApplicant)
				: '',
			employeeCfmRegistName: adminInfo?.isWorkerMasterRole
				? unitInfo?.managerName || ''
				: adminInfo?.name || '',
			employeeCfmDistrict: unitInfo?.countyDistrict || '',
			employeeCfmCity: adminInfo?.isWorkerMasterRole
				? unitInfo?.name
				: adminInfo?.departmentName || '',

			employeeCfmRegistDate: formatDate(dayjs()),
		};
	},
	pages: [
		{
			background: {
				src: Images.formConfirmEmployerPlaceWorkerHighlight,
				className: 'template',
				dataSource: Images.formConfirmEmployerPlaceWorker,
			},
			textAreas: [
				{
					name: 'employeeCfmRecruiterName',
					maxHeight: 37,
					maxLength: 30,
					containerClassName: 'absolute top-[264px] left-[253px] w-[210px]',
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employeeCfmAgriFisheryRegisNo',
					maxHeight: 37,
					maxLength: 15,
					containerClassName: 'absolute top-[300px] left-[253px] w-[210px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'employeeCfmRecruiterPhone',
					maxHeight: 37,
					maxLength: 15,
					containerClassName: 'absolute top-[300px] left-[589px] w-[106px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'employeeCfmFranchiseName',
					maxHeight: 50,
					maxLength: 40,
					containerClassName: 'absolute top-[362px] left-[253px] w-[210px]',
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employeeCfmFranchiseAddr',
					maxHeight: 50,
					maxLength: 20,
					containerClassName: 'absolute top-[362px] left-[589px] w-[106px]',
					className: 'text-[16px] leading-none',
				},
				{
					name: 'employeeCfmBusinessRegisNo',
					maxHeight: 44,
					maxLength: 15,
					containerClassName: 'absolute top-[413px] left-[253px] w-[210px]',
					regex: REGEX.ALLOW_NUMBER_SPECIAL_CHARS,
				},
				{
					name: 'employeeCfmFranchisePhone',
					maxHeight: 44,
					maxLength: 15,
					containerClassName: 'absolute top-[413px] left-[589px] w-[106px]',
				},

				{
					name: 'franchiseWorkplace',
					maxHeight: 44,
					maxLength: 60,
					containerClassName: 'absolute top-[589px] left-[253px] w-[445px]',
					className: 'text-[16px] leading-none',
				},

				{
					name: 'totalNumReq',
					maxHeight: 44,
					maxLength: 10,
					containerClassName: 'absolute top-[636px] left-[253px] w-[445px]',
					regex: REGEX.ALLOW_NUMBER,
					className: 'text-[16px] leading-none',
				},
				{
					name: 'totalNumDispatchWorker',
					maxHeight: 44,
					maxLength: 10,
					containerClassName: 'absolute top-[680px] left-[253px] w-[445px]',
					regex: REGEX.ALLOW_NUMBER,
					className: 'text-[16px] leading-none',
				},

				(values, index) => ({
					name: 'employeeCfmDistrict',
					maxHeight: 37,
					maxLength: 15,
					containerClassName: cn(
						'absolute top-[930px] left-[163px] w-[236px] z-[1]',
						values?.employeeCfmDistrict && 'bg-white'
					),
					className: 'text-right focus:bg-white bg-transparent text-base',
					defaultHeight: 30,
				}),
				(values, index) => ({
					name: 'position',
					maxHeight: 24,
					maxLength: 3,
					className: 'text-[16px] text-center',
					containerClassName: cn(
						'absolute top-[933px] left-[347px] w-[60px]',
						values?.employeeCfmDistrict && 'bg-white'
					),
					readOnly: true,
				}),
				{
					name: 'employeeCfmCity',
					maxHeight: 44,
					maxLength: 15,
					containerClassName: 'absolute top-[924px] left-[403px] w-[100px]',
					className: ' bg-transparent text-base text-center',
				},
				{
					name: 'employeeCfmRegistName',
					maxHeight: 28,
					maxLength: 15,
					className: 'text-base',
					containerClassName:
						'absolute w-[139px] h-[32px] top-[962px] left-[352px]',
				},
			],
			datePickers: [
				{
					name: 'recruiterBirth',
					className: 'w-[110px] [&>.ant-picker-input>input]:!text-[14px]',
					format: 'YYYY-MM-DD',
					containerClassName: 'absolute top-[270px] left-[585px]',
					style: { fontSize: '14px' },
				},
				{
					name: 'employeeCfmRegistDate',
					segmentedInputs: true,
					format: 'YYYY           MM             DD',
					style: { fontSize: '14px' },
					boxStyle: { marginTop: '-5px' },
					containerClassName: 'absolute top-[887px] left-[293px]',
				},
			],
			checkboxes: [
				{
					name: 'basicPlanConfirm',
					iconType: 'circle',
					options: BASIC_CONFIRM,
					classNames: [
						'absolute top-[512px] left-[423px]',
						'absolute top-[512px] left-[570px]',
					],
				},

				{
					name: 'recruitType',
					iconType: 'circle',
					options: BASIC_CONFIRM,
					classNames: [
						'absolute top-[558px] left-[423px]',
						'absolute top-[558px] left-[570px]',
					],
				},
			],
			signatures: [
				{
					name: 'employeeCfmSignature',
					className: 'absolute w-[80px] h-[42px] top-[961px] left-[495px]',
				},
			],
		},
	],
};
